$( document ).ready(function() {
    console.log( "ready!" );
    AOS.init();
    
    $('[data-toggle="tooltip"]').tooltip();
    var oremoveClass = $.fn.removeClass;
	$.fn.removeClass = function () {
	    for (var i in arguments) {
	        var arg = arguments[i];
	        if ( !! (arg && arg.constructor && arg.call && arg.apply)) {
	            arg();
	            delete arg;
	        }
	    }
	    return oremoveClass.apply(this, arguments);
	}
    
   
    $(function() {
	function checkScroll(){
		
	
		 $('.fullheight') .css({'min-height': (($(window).height()) - $('footer').innerHeight() - $('.navbar').innerHeight())+'px'});
		
		var menu = $('.navbar');
		var hieghtThreshold = $(".section-holder").offset().top;
		var hieghtThreshold_end  = $(".section-holder").offset().top + $(".section-holder").height() ;
	    var scroll = $(window).scrollTop();
		if (scroll >= hieghtThreshold && scroll <=  hieghtThreshold_end ) {
		//if (scroll >= 70 ) {
	        menu.addClass('navbar-light');
	        menu.removeClass('navbar-dark');
	        menu.removeClass('bg-primary');
	        if ($(window).scrollTop() >= (($(document).height() - $(window).height()) - $('footer').innerHeight())) {
		       
		       $('.contact-action').addClass('d-none');
		       $('.contact-action').removeClass('animated');
		       
		    } else {
		       $('.contact-action').removeClass('d-none');
		        $('.contact-action').removeClass('d-none', function(e){
			        if(!($('.contact-action').hasClass('animated'))){
				        $('.counter').counterUp({
						  delay: 10,
						  time: 900
						});
						$('.contact-action').addClass('animated');
			        }
				});
		    }
	    } else {
	        menu.removeClass('navbar-light');
	        menu.addClass('navbar-dark ');
	        //menu.addClass('bg-primary');
			$('.contact-action').addClass('d-none');
		    $('.contact-action').removeClass('animated');
	    }
	    
		if (scroll >= 70 ) {
	        menu.addClass('navbar-light');
	        menu.removeClass('navbar-dark');
	        menu.removeClass('bg-primary');
	       
	    } else {
	        menu.removeClass('navbar-light');
	        menu.addClass('navbar-dark ');
	        //menu.addClass('bg-primary');
	    }
	    
	    
	}
	checkScroll()
	$(window).scroll(function() {
	   checkScroll()
	   
	  });
	})
	window.onresize = function() {
	     $('.fullheight') .css({'min-height': (($(window).height()) - $('footer').innerHeight() - $('.navbar').innerHeight())+'px'});
	}
	$('a[href*=#]:not([href=#])').click(function() {
	    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
	      var target = $(this.hash);
	      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
	      if (target.length) {
	        $('html,body').animate({
	          scrollTop: target.stop().offset().top - $('.navbar').height(), scrollLeft:target.stop().offset().left-10
	        }, 500);
	        return false;
	      }
	    }
	  });
	$('#videoModal').on('hidden.bs.modal', function () {
	    $("#videoModal iframe").attr("src", $("#videoModal iframe").attr("src"));
	});
	
	
	$('#formModal').on('show.bs.modal', function () {
	    var mod = $('#appointmentMakingForm'); //Create variable and load modal in it
	    $('.insidemodal').html(mod); //Load modal to `insidemodal` Selector
	});
	$('#formModal').on('hide.bs.modal', function () {
	    var mod = $('#appointmentMakingForm'); //Create variable and load modal in it
	    $('.contact-form-holder').html(mod); //Load modal to `insidemodal` Selector
	});
	function randomBetween(min, max) {
	    if (min < 0) {
	        return min + Math.random() * (Math.abs(min)+max);
	    }else {
	        return min + Math.random() * max;
	    }
	}
	$("#share").jsSocials({
	    showLabel: false,
	    showCount: false,
	    shares: ["email", "facebook", "linkedin", "whatsapp"]
	});
	
	
/*
	$('.fly-text-holder .fly-text').each(function() {
	   $(this).css({"opacity":  randomBetween(0.1, 0.15) , "font-size":  randomBetween(150, 300) + '%' , "top": randomBetween( -30, $('.section-start').height()) });
	   $(this).css('left', randomBetween( -2000, -1000));
	   $(this).animate({left: randomBetween(2000, 2500)}, randomBetween(15000, 18000), 'linear', function() {
	        $(this).css('left', randomBetween( -2000, -1000));
	        animate();
	    });
	});
	function animate (){
		$(".fly-text").animate({left: randomBetween(2000, 2500)}, randomBetween(15000, 18000), 'linear', function() {
	        $(this).css('left', randomBetween( -2000, -1000));
	        animate();
	      });
	}
*/
/*
	$("#share").jsSocials({
	    showLabel: false,
	    showCount: false,
	    shares: ["email", "facebook", "linkedin", "whatsapp"]
	});
*/
		
	jQuery(function ($) {
	  $('#myFlipper').flipper('init');
	  $('#modalFlipper').flipper('init');
	});
});